import L from 'leaflet'
/*
*创建地图实例
*/
const createrMap = (name, option) => {
  let map = L.map(name, option)
  map.setView(option.center, option.zoom);

  return map
}
/*
*创建基本地图图层
*/
const createrLayers = (map, url, option) => {
  let layers = L.tileLayer(url, option)
  layers.addTo(map)

  //影像地图标注
  let cia_w_url =  "http://t{s}.tianditu.gov.cn/cia_w/wmts?tk=4567b571b8fcdd8c6e2f059d96828047&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TileMatrix={z}&TileCol={x}&TileRow={y}";
  let cia_w =  L.tileLayer(cia_w_url, option)
  cia_w.addTo(map)

  return layers
}
/*
*创建WMS图层
*/
const createrLayersWms = (map, url, option) => {
  let wmsLayer = L.tileLayer.wms(url, option)
  wmsLayer.addTo(map)
  return wmsLayer
}
/*
*使用chinatmsproviders插件创建
*/
const createrChinatm = (map, url, option) => {
  let chinatm = L.tileLayer.chinaProvider(url, option)
  chinatm.addTo(map)
  return chinatm
}
export default {
  createrMap,
  createrLayers,
  createrLayersWms,
  createrChinatm
}